<template class="loginbody">
  <div class="login-page">
      <b-overlay :show="overlay" rounded="sm">
        <div class="form">
            <form class="login-form" @submit="login">
                <input focus type="text" :placeholder="$t('username')" v-model="loginData.username" required/>
                <input type="password" :placeholder="$t('password')" v-model="loginData.password" required/>
                <LangSwitcher style="margin-bottom:10px"/>
                <button type="submit">{{ $t('login') }} </button>
            </form>
        </div>
      </b-overlay>
  </div>
</template>

<script>
import api from '@/utils/api.js'
import LangSwitcher from '@/components/langSwitcher'

export default {
  components: {
    LangSwitcher
  },
  data () {
    return {
      loginData: {
        username: '',
        password: ''
      },
      overlay: false
    }
  },
  methods: {
    async login () {
      this.overlay = true
      try {
        let response = await api.post(this.$store.getters.API_LOGIN, this.loginData)
        if (response.status === 200) {
          let data = response.data
          if (data.hasOwnProperty('session_id')) {
            this.$cookie.set('session_id', data.session_id, { expires: '1D' })
            this.$router.push('dashboard')
          }
        }
        if (response.status === 400) {
          this.$bvToast.toast(this.$t('User or password incorrect'), {
            title: this.$t('Error'),
            variant: 'danger',
            solid: true
          })
        }
      } finally {
        this.overlay = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Login.vue